import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '../types';
import { ListsState } from './types';

export const actions: ActionTree<ListsState, RootState> ={

};